import Vue from 'vue'
import Router from 'vue-router'

//路由的懒加载
const Home = () => import('../components/Home')
const Welcome = () => import('../components/Welcome')
const About = () => import('../components/About')
const Product = () => import('../components/Product')
const Serve = () => import('../components/Serve')
const Cantact = () => import('../components/Cantact')

Vue.use(Router)

export default new Router({
  routes: [
    // 路由默认路径是home主页
    {
      path: '',
      redirect: 'home'
    },
    //主页的默认子路由是welcome页面
    {
      path: '/home',
      component: Home,
      redirect: 'welcome',
      children: [
        {
          path: '/welcome',
          component: Welcome
        },
        {
          path: '/about',
          component: About
        },
        {
          path: '/product',
          component: Product
        },
        {
          path: '/serve',
          component: Serve
        },
        {
          path: '/cantact',
          component: Cantact
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js